var map = {
	"./act-en.json": 1032,
	"./act-es.json": 9917,
	"./amh.json": 1946,
	"./ar.json": 9675,
	"./chk.json": 5445,
	"./de.json": 532,
	"./en.json": 1005,
	"./es.json": 3458,
	"./fa.json": 3331,
	"./fr.json": 1822,
	"./hi.json": 8274,
	"./hmn.json": 6228,
	"./ja.json": 5723,
	"./kar.json": 3356,
	"./km.json": 3313,
	"./ko.json": 3355,
	"./lo.json": 8319,
	"./mh.json": 1857,
	"./mix.json": 9229,
	"./my.json": 7072,
	"./ne.json": 4131,
	"./om.json": 550,
	"./pa.json": 2882,
	"./ps.json": 7040,
	"./pt.json": 6709,
	"./ro.json": 20,
	"./ru.json": 8809,
	"./sm.json": 7080,
	"./so.json": 2538,
	"./sw.json": 6248,
	"./ta.json": 8990,
	"./te.json": 7711,
	"./th.json": 6734,
	"./ti.json": 4525,
	"./tl.json": 725,
	"./uk.json": 7048,
	"./ur.json": 1026,
	"./vi.json": 3821,
	"./zh_CN.json": 5947,
	"./zh_TW.json": 3270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5189;